import { render, staticRenderFns } from "./MetricsBox.vue?vue&type=template&id=505ba9cc&"
import script from "./MetricsBox.vue?vue&type=script&lang=js&"
export * from "./MetricsBox.vue?vue&type=script&lang=js&"
import style0 from "./MetricsBox.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports